export default "__VITE_ASSET__DnDYkLHD__"